import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getAllPoets } from '../../services/poetsService';

export default class Themes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            poets: getAllPoets()
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                {this.state.poets.map((poet) => {
                    <div>
                        {poet.name}
                        <img src={poet.asset} alt="" />
                        <p>{poet.bio}</p>
                    </div>
                })}

            </div>
        );
    }
}
